/* ========================================================
   ROYAL EXPRESS — OKOP KP-215 EARBUDS DTC SHOPIFY THEME LOGIC
   Plus Jakarta Sans • 2 Color Cards • Dynamic Gallery • EasySell COD Integration
   ======================================================== */

document.addEventListener('DOMContentLoaded', () => {
  // Galleries per color (loaded from Liquid CDN URLs or local fallback)
  const defaultGalleries = {
    'Negro': [
      { src: 'earbuds_negro_1_hero.webp', label: 'Estuche con LED' },
      { src: 'earbuds_negro_2_table.webp', label: 'Estuche y Audífonos' },
      { src: 'earbuds_negro_3_ergonomia.webp', label: 'Diseño Ergonómico' },
      { src: 'earbuds_negro_4_transparencia.webp', label: 'Tecnología Interna' },
      { src: 'earbuds_negro_5_exploded.webp', label: 'Vista Desmontada' },
      { src: 'earbuds_negro_6_kit.webp', label: 'Contenido del Paquete' }
    ],
    'Blanco': [
      { src: 'earbuds_blanco_1_hero.webp', label: 'Estuche con LED' },
      { src: 'earbuds_blanco_2_ergonomia.webp', label: 'Diseño Ergonómico' },
      { src: 'earbuds_blanco_3_transparencia.webp', label: 'Tecnología Interna' },
      { src: 'earbuds_blanco_4_exploded.webp', label: 'Vista Desmontada' },
      { src: 'earbuds_blanco_5_kit.webp', label: 'Contenido del Paquete' }
    ]
  };

  const colorGalleries = window.RoyalColorGalleries || defaultGalleries;
  const colorThumbs = window.RoyalColorThumbs || {};

  // Variant Map for Audífonos Pro Crystal Sound on Shopify (wk0nne-06)
  const variantMap = window.RoyalVariantMap || {
    'Negro': 67711258231104,
    'Blanco': 67711258263872
  };

  let currentColor = 'Negro';
  let currentAngleIndex = 0;
  let currentQty = 1;
  const unitPrice = 129900;

  // DOM Elements
  const mainImage = document.getElementById('mainImage');
  const mainImageWrap = document.getElementById('mainImageWrap');
  const galleryCounter = document.getElementById('galleryCounter');
  const gallerySwipeHint = document.getElementById('gallerySwipeHint');
  const galleryPrevBtn = document.getElementById('galleryPrevBtn');
  const galleryNextBtn = document.getElementById('galleryNextBtn');
  const selectedColorLabel = document.getElementById('selectedColorLabel');
  const colorCards = document.querySelectorAll('.color-card');

  const inputQuantity = document.getElementById('inputQuantity');
  const btnQtyMinus = document.getElementById('btnQtyMinus');
  const btnQtyPlus = document.getElementById('btnQtyPlus');
  const btnCodBuy = document.getElementById('btnCodBuy');

  // Sticky Bottom Bar Elements
  const stickyMobileBar = document.getElementById('stickyBottomBar') || document.getElementById('stickyMobileBar');
  const stickyBarThumb = document.getElementById('stickyBarThumb');
  const stickyBarModel = document.getElementById('stickyBarModel');
  const stickyBuyBtn = document.getElementById('stickyBuyBtn');
  const stickyProductInfo = document.getElementById('stickyBarProductInfo');

  // Fallback COD Modal Elements
  const codModal = document.getElementById('codModal');
  const codModalOverlay = document.getElementById('codModalOverlay');
  const codModalClose = document.getElementById('codModalClose');
  const codFormView = document.getElementById('codFormView');
  const codSuccessView = document.getElementById('codSuccessView');
  const codOrderForm = document.getElementById('codOrderForm');
  const btnCloseSuccess = document.getElementById('btnCloseSuccess');

  const modalProductImg = document.getElementById('modalProductImg');
  const modalSelectedColor = document.getElementById('modalSelectedColor');
  const modalSelectedQty = document.getElementById('modalSelectedQty');
  const modalOrderTotal = document.getElementById('modalOrderTotal');

  // Currency Formatter (COP)
  function formatCOP(amount) {
    return '$' + amount.toLocaleString('es-CO') + ',00';
  }

  // Update gallery controls visibility
  function updateGalleryUI() {
    const list = colorGalleries[currentColor] || [];

    if (list.length <= 1) {
      if (gallerySwipeHint) gallerySwipeHint.style.display = 'none';
      if (galleryPrevBtn) galleryPrevBtn.style.display = 'none';
      if (galleryNextBtn) galleryNextBtn.style.display = 'none';
      if (galleryCounter) galleryCounter.style.display = 'none';
    } else {
      if (gallerySwipeHint) gallerySwipeHint.style.display = 'flex';
      if (galleryPrevBtn) galleryPrevBtn.style.display = 'flex';
      if (galleryNextBtn) galleryNextBtn.style.display = 'flex';
      if (galleryCounter) galleryCounter.style.display = 'block';
    }
  }

  // Set Angle for current color
  function setAngle(index) {
    const list = colorGalleries[currentColor] || [];
    if (list.length === 0) return;
    if (index < 0) index = list.length - 1;
    if (index >= list.length) index = 0;
    currentAngleIndex = index;

    const angleData = list[currentAngleIndex];
    if (galleryCounter) {
      galleryCounter.textContent = `${currentAngleIndex + 1} / ${list.length}`;
    }

    if (mainImage) {
      mainImage.style.opacity = '0.25';
      mainImage.style.transform = 'scale(0.98)';
      setTimeout(() => {
        mainImage.src = angleData.src;
        mainImage.style.opacity = '1';
        mainImage.style.transform = 'scale(1)';
      }, 110);
    }
  }

  // Gallery prev / next buttons
  if (galleryPrevBtn) {
    galleryPrevBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const list = colorGalleries[currentColor] || [];
      if (list.length > 1) {
        setAngle(currentAngleIndex - 1);
      }
    });
  }

  if (galleryNextBtn) {
    galleryNextBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const list = colorGalleries[currentColor] || [];
      if (list.length > 1) {
        setAngle(currentAngleIndex + 1);
      }
    });
  }

  // Update Selected Variant in Hidden Form
  function updateSelectedVariant() {
    const varId = String(variantMap[currentColor] || '67711258231104');
    const input = document.getElementById('selectedVariantId');
    if (input) {
      input.value = varId;
      input.setAttribute('value', varId);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    // Sync all name="id" inputs on forms for third-party COD apps like EasySell
    document.querySelectorAll('form[action*="/cart/add"] [name="id"], #AddToCartForm [name="id"]').forEach(el => {
      el.value = varId;
      el.setAttribute('value', varId);
    });
    const colorInput = document.getElementById('selectedColor');
    if (colorInput) {
      colorInput.value = currentColor;
    }
    const selQty = document.getElementById('selectedQuantity');
    if (selQty) {
      selQty.value = String(currentQty);
      selQty.setAttribute('value', String(currentQty));
      selQty.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Set Color Variant
  function setColor(colorName) {
    currentColor = colorName;
    currentAngleIndex = 0;

    if (selectedColorLabel) selectedColorLabel.textContent = currentColor;

    // Update rectangular color cards
    colorCards.forEach(card => {
      if (card.dataset.color === currentColor) {
        card.classList.add('active');
      } else {
        card.classList.remove('active');
      }
    });

    updateGalleryUI();
    setAngle(0);

    // Update sticky & modal
    const list = colorGalleries[currentColor];
    const primarySrc = (list && list[0]) ? list[0].src : (colorThumbs[currentColor] || '');
    if (stickyBarThumb && primarySrc) stickyBarThumb.src = primarySrc;
    if (stickyBarModel) {
      stickyBarModel.textContent = currentColor;
    }
    if (modalProductImg && primarySrc) modalProductImg.src = primarySrc;
    if (modalSelectedColor) modalSelectedColor.textContent = currentColor;

    updateSelectedVariant();
  }

  // Initialize gallery on load
  updateGalleryUI();
  setAngle(0);
  updateSelectedVariant();

  // Click on rectangular color cards
  colorCards.forEach(card => {
    card.addEventListener('click', () => {
      setColor(card.dataset.color);
    });
  });

  // EasySell Configuration Overrides
  window.ES_QUANTITY_SELECTOR_OVERRIDE = '#selectedQuantity';
  window.ES_VARIANT_SELECTOR_OVERRIDE = '#selectedVariantId';

  // Master Quantity Synchronizer (Syncs UI, Hidden Form Input, Sticky Bar, and EasySell COD Modal)
  function setQuantity(newQty) {
    const parsed = parseInt(newQty, 10);
    currentQty = isNaN(parsed) || parsed < 1 ? 1 : Math.min(10, parsed);

    if (inputQuantity) {
      inputQuantity.value = currentQty;
      inputQuantity.setAttribute('value', currentQty);
    }

    const selQty = document.getElementById('selectedQuantity');
    if (selQty) {
      selQty.value = String(currentQty);
      selQty.setAttribute('value', String(currentQty));
      selQty.dispatchEvent(new Event('change', { bubbles: true }));
      selQty.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // Sync any EasySell internal inputs if already rendered in DOM
    document.querySelectorAll('[name="es-quantity-picker"], .quantity-picker-input').forEach(el => {
      if (parseInt(el.value, 10) !== currentQty) {
        el.value = currentQty;
        el.setAttribute('value', String(currentQty));
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    updateTotals();
  }

  // Quantity Handlers
  if (btnQtyMinus) {
    btnQtyMinus.addEventListener('click', (e) => {
      e.preventDefault();
      if (currentQty > 1) {
        setQuantity(currentQty - 1);
      }
    });
  }

  if (btnQtyPlus) {
    btnQtyPlus.addEventListener('click', (e) => {
      e.preventDefault();
      if (currentQty < 10) {
        setQuantity(currentQty + 1);
      }
    });
  }

  if (inputQuantity) {
    inputQuantity.addEventListener('change', () => {
      setQuantity(inputQuantity.value);
    });
  }

  // Listen for changes inside EasySell modal quantity picker
  document.addEventListener('input', (e) => {
    if (e.target && (e.target.name === 'es-quantity-picker' || e.target.classList.contains('quantity-picker-input'))) {
      const val = parseInt(e.target.value, 10);
      if (!isNaN(val) && val >= 1 && val !== currentQty) {
        currentQty = Math.min(10, val);
        if (inputQuantity) {
          inputQuantity.value = currentQty;
          inputQuantity.setAttribute('value', currentQty);
        }
        const selQty = document.getElementById('selectedQuantity');
        if (selQty) {
          selQty.value = String(currentQty);
          selQty.setAttribute('value', String(currentQty));
        }
        updateTotals();
      }
    }
  });

  function updateTotals() {
    const total = currentQty * unitPrice;
    if (modalSelectedQty) modalSelectedQty.textContent = currentQty;
    if (modalOrderTotal) modalOrderTotal.textContent = formatCOP(total);
    const stickyPriceVal = document.querySelector('.sticky-price-val');
    if (stickyPriceVal) {
      stickyPriceVal.textContent = formatCOP(total);
    }
  }

  // Touch Swipe Gesture on Gallery (Mobile swipe left/right)
  let touchStartX = 0;
  let touchEndX = 0;

  if (mainImageWrap) {
    mainImageWrap.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    mainImageWrap.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });
  }

  function handleSwipe() {
    const threshold = 35;
    if (touchEndX < touchStartX - threshold) {
      setAngle(currentAngleIndex + 1);
    } else if (touchEndX > touchStartX + threshold) {
      setAngle(currentAngleIndex - 1);
    }
  }

  // EasySell COD Trigger Function (Reliable & Instant)
  function triggerEasySell(retryCount = 0) {
    updateSelectedVariant();
    setQuantity(currentQty);

    const form = document.getElementById('AddToCartForm');
    if (form) {
      window.ES_CLOSEST_FORM = form;
    }

    const currentVariantId = document.getElementById('selectedVariantId')?.value || String(variantMap[currentColor] || '67711258231104');

    // Clean cart and add current valid variant to avoid stale invalid variant errors
    try {
      if (window.fetch) {
        fetch('/cart/clear.js', { method: 'POST' }).then(() => {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(currentVariantId, 10), quantity: currentQty }] })
          }).catch(() => {});
        }).catch(() => {});
      }
    } catch (e) {}

    // 1. EasySell native global opener function
    if (typeof window.openTysloForm === 'function') {
      try {
        window.openTysloForm();
        return true;
      } catch (err) {
        console.warn('openTysloForm error:', err);
      }
    }

    // 2. Direct EasySell Modal Display
    const esModal = document.getElementById('easysell-modal');
    if (esModal) {
      try {
        esModal.style.setProperty('display', 'block', 'important');
        document.querySelectorAll('html, body').forEach(n => {
          n.style.overflow = 'hidden';
        });
        return true;
      } catch (e) {}
    }

    // 3. Query any internal EasySell button and click it
    const candidates = [
      '.es-popup-button:not(#btnCodBuy):not(#stickyBuyBtn)',
      '.es-button:not(#btnCodBuy):not(#stickyBuyBtn)',
      '.easysell-btn:not(#btnCodBuy):not(#stickyBuyBtn)',
      '[id*="easysell"] button:not(#btnCodBuy):not(#stickyBuyBtn)',
      '.es-checkout-btn',
      '.es-cta-btn'
    ];
    for (const sel of candidates) {
      const btn = document.querySelector(sel);
      if (btn && btn !== stickyBuyBtn && btn !== btnCodBuy) {
        try {
          btn.click();
          return true;
        } catch (e) {}
      }
    }

    // 4. EasySell app object listener fallback
    if (window.easysellApp && typeof window.easysellApp.popupListner === 'function') {
      try {
        window.easysellApp.popupListner();
        return true;
      } catch (e) {}
    }
    if (window.EasySell && typeof window.EasySell.open === 'function') {
      try {
        window.EasySell.open();
        return true;
      } catch (e) {}
    }

    // 5. Retry loop for slow EasySell scripts loading
    if (retryCount < 5) {
      setTimeout(() => triggerEasySell(retryCount + 1), 200);
      return;
    }

    // 6. Final Fallback: Open clean built-in COD modal
    openCustomCodModal();
  }

  // Open Built-in COD Modal (Fallback)
  function openCustomCodModal() {
    if (!codModal) return;
    updateTotals();
    if (codFormView) codFormView.style.display = 'block';
    if (codSuccessView) codSuccessView.style.display = 'none';
    codModal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCustomCodModal() {
    if (!codModal) return;
    codModal.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Wire up CTA buttons to EasySell
  if (btnCodBuy) {
    btnCodBuy.addEventListener('click', (e) => {
      e.preventDefault();
      triggerEasySell();
    });
  }

  if (stickyBuyBtn) {
    stickyBuyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      triggerEasySell();
    });
  }

  // Modal close handlers
  if (codModalClose) codModalClose.addEventListener('click', closeCustomCodModal);
  if (codModalOverlay) codModalOverlay.addEventListener('click', closeCustomCodModal);
  if (btnCloseSuccess) btnCloseSuccess.addEventListener('click', closeCustomCodModal);

  // Dynamic Shipping Delivery Dates (Colombia)
  function initDynamicDates() {
    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    const now = new Date();

    const d1 = new Date(now);
    const d2 = new Date(now);
    d2.setDate(d2.getDate() + 1);

    const d3Start = new Date(now);
    d3Start.setDate(d3Start.getDate() + 2);

    const d3End = new Date(now);
    d3End.setDate(d3End.getDate() + 5);

    const strD1 = `${d1.getDate()} ${months[d1.getMonth()]}`;
    const strD2 = `${d2.getDate()} ${months[d2.getMonth()]}`;
    const strD3 = `${d3Start.getDate()} - ${d3End.getDate()} ${months[d3End.getMonth()]}`;

    const dateEl1 = document.getElementById('checkpointDate1');
    const dateEl2 = document.getElementById('checkpointDate2');
    const dateEl3 = document.getElementById('checkpointDate3');

    if (dateEl1) dateEl1.textContent = strD1;
    if (dateEl2) dateEl2.textContent = strD2;
    if (dateEl3) dateEl3.textContent = strD3;
  }
  initDynamicDates();

  // Sticky Bar On Scroll
  if (stickyProductInfo) {
    stickyProductInfo.addEventListener('click', () => {
      const targetArea = document.getElementById('buyActionArea') || document.getElementById('product');
      if (targetArea) {
        targetArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  window.addEventListener('scroll', () => {
    const triggerEl = document.getElementById('buyActionArea') || btnCodBuy;
    if (stickyMobileBar && triggerEl) {
      const rect = triggerEl.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyMobileBar.classList.add('visible');
      } else {
        stickyMobileBar.classList.remove('visible');
      }
    }
  }, { passive: true });

  // Scroll to description on rating click
  const ratingWrap = document.getElementById('scrollToReviews');
  if (ratingWrap) {
    ratingWrap.addEventListener('click', () => {
      const descSec = document.getElementById('description');
      if (descSec) {
        descSec.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
});
